<template>
  <v-container 
    class="pt-0"
    fluid>
    <v-row align="center">
      <v-col cols="12">
        <validacoes-sdi-data-table
          :items="items"
          :loading="loading"
          @rechargeTable="getAllValidacoes()"
          @switchProcessamentosExpirados="
            processamentosExpirados = $event,
            getAllValidacoes()
          "
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ValidacoesSdiService from '@/services/ValidacoesSdiService';
import tourMixins from '@/mixins/tourMixins';
import pusherMixins from '@/mixins/pusherMixins';

export default {

  components: {
    ValidacoesSdiDataTable: () => import('@/components/validacoesSdi/ValidacoesSdiDataTable.vue')
  },
  mixins: [pusherMixins, tourMixins],

  data: () => ({
    items: [],
    loading: false,
    processamentosExpirados: false,
    arrTour: [
      {
        element: '#btn-nova-valid-sdi',
        intro: 'Clicando neste botão você poderá criar novas validações de sdi.',
        scrollTo: 'tooltip',
        position: 'right'
      },
      {
        element: '#valid-sdi-historico-search',
        intro: 'Neste campo você poderá pesquisar por validações de sdi já existentes.',
        scrollTo: 'tooltip',
        position: 'bottom'
      },
      {
        element: '#action-download-valid-sdi',
        intro: 'Clicando neste ícone você poderá fazer o download em .XLSX do resultado de sua validação de sdi.',
        scrollTo: 'tooltip',
        position: 'left'
      },
      {
        element: '#action-more-validacao-sdi',
        intro: 'Aqui você acessa outras opções para sua validação de sdi, como ver mais detalhes, executá-la novamente ou deletá-la.',
        scrollTo: 'tooltip',
        position: 'left'
      }
    ]
  }),

  mounted() {
    this.subscribe();
    this.getAllValidacoes();
  },

  methods: {
    subscribe() {
      this.pusherChannel.bind('reload-pag-validacao-sdi', () => {
        this.getAllValidacoes();
      });
    },

    getAllValidacoes() {
      this.loading = true;

      ValidacoesSdiService.getAllValidacoes(this.processamentosExpirados)
        .then(resp => this.items = resp.data.data)
        .catch(err => {
          this.$toast.error('Erro ao recuperar as Validações de SDI.', '', { position: 'topRight'});
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
          this.iniciarTourPagina();
        });
    },

    iniciarTourPagina() {
      if (this.tourFuncCalled) return;
  
      let arrTourFormatted = this.items.length ? this.arrTour : this.arrTour.splice(0, 2);
      this.iniciarTour(arrTourFormatted);
    }
  }
};
</script>